import React, { FC } from 'react';
import { EntitiesCardTitle } from '../../components/entities-card/EntitiesCardTitle';
import { EntitiesTitleLink } from '../../components/entities-card/EntitiesTitleLink';

export const EnterpriseCardTitle: FC<React.HTMLProps<HTMLAnchorElement>> = ({
  children,
  ...props
}) => (
  <EntitiesTitleLink {...props}>
    <EntitiesCardTitle>{children}</EntitiesCardTitle>
  </EntitiesTitleLink>
);
